<h2 mat-dialog-title> Isin {{ data.isin }} </h2>
<mat-dialog-content>
  <ng-container *ngIf="error; else content">
    <div class="alert cedlab-danger">Errore nel caricamento dei portafogli</div>
  </ng-container>

  <ng-template #content>
    <ng-container *ngIf="portfolios$ | async as data; else loading">
      <div *ngIf="data.length" class="my-3">
        <mat-selection-list [multiple]="false">
          <mat-list-option *ngFor="let item of data" (click)="onSelectPortfolio(item)"> {{ item.name }} </mat-list-option>
        </mat-selection-list>
      </div>

      <div *ngIf="!data.length" class="alert cedlab-info">Isin non presente nei portafogli</div>
    </ng-container>

    <ng-template #loading>
      <div class="d-flex justify-content-center my-3"><app-loader></app-loader></div>
    </ng-template>
  </ng-template>
</mat-dialog-content>
